import { computed } from 'vue';
import { useAccessStore } from '@/modules/core/stores/access.store.ts';
import { getCounterpartyMasterAccess } from '@/modules/counterparty/counterparty-master/utils/counterparty-master-access.util.ts';

export function useCounterpartyMasterAccess() {
  const accessStore = useAccessStore();

  return computed(() => {
    const list = accessStore.list;

    return getCounterpartyMasterAccess((access) => !!list?.includes(access));
  });
}
